import styled from 'styled-components';
import { Paper } from '@material-ui/core';
import { Link } from 'react-router-dom';

export const StyledPaper = styled(Paper)`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: ${({ theme }) => theme.colors.white};
    padding: ${({ theme }) => theme.spacing * 4}px ${({ theme }) => theme.spacing * 6}px;
    > button {
        height: 24px;
        border: none;
        padding: 0;
        background-color: unset;
        font-size: 14px;
        color: ${({ theme }) => theme.colors.blue};
        opacity: .87;
        outline: none;
        cursor: pointer;
    }
`;

export const StyledLink = styled(Link)`
    font-size: 14px;
    line-height: 24px;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.blue};
    opacity: .87;
`;
